export default __webpack_public_path__ + "static/residential-sales-2e31925f40d8fd07eb393484014ebced.png";